/* eslint-disable */
import React, { useState } from "react";

/// React router dom
import { Link } from "react-router-dom";

/// images
import logo from "../../../assets/images/logos/logomark.svg";
import logoText from "../../../assets/images/logos/logo.svg";

const NavHeader = () => {
   const [toggle, setToggle] = useState(false);

   return (
      <div className="nav-header">
         <Link to="/" className="brand-logo">
            <img className="logo-abbr animated fadeIn" src={logo} alt="" />
            <img className="logo-compact  animated fadeInRight" src={logoText} alt="" />
            <img className="brand-title  animated fadeIn" src={logoText} alt="" />
         </Link>

         <div className="nav-control" onClick={() => setToggle(!toggle)}>
            <div className={`hamburger ${toggle ? "is-active" : ""}`}>
               <span className="line"></span>
               <span className="line"></span>
               <span className="line"></span>
            </div>
         </div>
      </div>
   );
};

export default NavHeader;
